import type { GetPortfolioKpisResponseDto } from './portfolio-kpi.types';

/** Stand-in payload until the portfolio KPI API is on main. */
export const PORTFOLIO_KPIS_MOCK: GetPortfolioKpisResponseDto = {
  siteCount: 28,
  chargerCount: 300,
  sitesNeedingAttention: {
    needingAttentionCount: 8,
    totalChargers: 300,
    breachOrLateCount: 6,
  },
  contractCompliance: {
    score: 87,
    maxScore: 100,
    belowTarget: true,
  },
  claimablePenalties: {
    totalEuros: 3400,
    lines: [
      {
        id: 'horizon-mall',
        siteName: 'Horizon Mall',
        statusLabel: 'Breach',
        amountEuros: 1800,
      },
      {
        id: 'commune-e',
        siteName: 'Commune E',
        statusLabel: 'Breach',
        amountEuros: 1600,
      },
    ],
  },
  penaltyExposure: {
    totalEuros: 2200,
    lines: [
      {
        id: 'east-paris-hotel',
        siteName: 'East Paris Hotel',
        statusLabel: 'Late',
        amountEuros: 900,
      },
      {
        id: 'lyon-logistics-hub',
        siteName: 'Lyon Logistics Hub',
        statusLabel: 'Late',
        amountEuros: 700,
      },
      {
        id: 'bordeaux-quay',
        siteName: 'Bordeaux Quay',
        statusLabel: 'Late',
        amountEuros: 600,
      },
    ],
  },
};
